const QUOTE_INITIAL_FILTERS = {
  customerName: null,
  customerDocumentNumber: null,
  quoteNumber: null,
  salesAgentId: null,
  headerStatus: null,
  initDate: null,
  endDate: null,
  pageNumber: 1,
  pageSize: 10,
}

export function buildQuoteSearchPayload(filters) {
  const hasDateRange = filters.initDate || filters.endDate
  const hasHeaderStatus = filters.headerStatus?.length > 0
  const hasActiveFilters =
    filters.customerName ||
    filters.customerDocumentNumber ||
    filters.quoteNumber ||
    filters.salesAgentId ||
    hasHeaderStatus ||
    hasDateRange
  const toDateOnly = dateStr => (dateStr ? dateStr.substring(0, 10) : undefined)
  const warehouseIds =
    hasActiveFilters || !filters.warehouseId ? undefined : [filters.warehouseId]

  return {
    pageNumber: filters.pageNumber,
    pageSize: filters.pageSize,
    companyId: filters.companyId,
    warehouseIds,
    customerName: filters.customerName || undefined,
    customerNumber: filters.customerDocumentNumber || undefined,
    quoteNumber: filters.quoteNumber || undefined,
    salesAgentId: filters.salesAgentId || undefined,
    headerStatusIds: hasHeaderStatus ? filters.headerStatus : undefined,
    dateStart: toDateOnly(filters.initDate),
    dateEnd: toDateOnly(filters.endDate),
    ignoreDateFilter: hasDateRange ? undefined : true,
  }
}

export const quoteFilterFields = [
  {
    key: 'quoteNumber',
    i18nKey: 'SEARCH_QUOTATION_T.NUMBER_QUOTATION_LABEL',
    testId: 'input-quoteid-filter',
  },
]

export const quoteDocumentsSearchConfig = {
  initialFilters: QUOTE_INITIAL_FILTERS,
  buildPayload: buildQuoteSearchPayload,
}
